import React from "react";

const CPP = () => {
  return (
    <div>
      <h1>CPP Component</h1>
      <p>Content for CPP goes here...</p>
    </div>
  );
};

export default CPP;
